import api from "src/api/axios";

const createUserType = async (input) => {
  return api.post(`/user-type`, input).then((result) => {
    return result.data;
  });
};

const updateUserType = async (input, id) => {
  return api.patch(`/user-type/${id}`, input).then((result) => {
    return result.data;
  });
};

const updateActiveStatus = async (input, id) => {
  return api.patch(`/user-type/active-inactive/${id}`, input).then((result) => {
    return result.data;
  });
};

const getUserTypeList = async (searchParams) => {
  const params = new URLSearchParams();
  Object.keys(searchParams).map((key) => {
    if (searchParams[key]) {
      params.append(key, searchParams[key]);
    }
  });
  return api.get(`/user-type?${params}`).then((result) => {
    return result.data;
  });
};

const getAllUserTypeBySearch = async (param) => {
  const params = new URLSearchParams({
    page: param.page ? param.page : "1",
    limit: param.limit ? param.limit : "10",
    type: param.type ? param.type : "",
  });
  return api.get(`/user-type?${params}`).then((result) => {
    return result.data;
  });
};

const getAllUserTypeList = async () => {
  return api.get(`/user-type`).then((result) => {
    return result.data;
  });
};

const getAllActiveUserTypeList = async () => {
  return api.get(`/user-type/list`).then((result) => {
    return result.data;
  });
};

const getSingleUserType = async (id) => {
  return api.get(`/user-type/${id}`).then((result) => {
    return result.data;
  });
};

export {
  createUserType,
  getUserTypeList,
  getSingleUserType,
  updateUserType,
  getAllUserTypeList,
  updateActiveStatus,
  getAllActiveUserTypeList,
  getAllUserTypeBySearch,
};
